/**
 * Nadhor Arabian Oud — Light Sands
 * Lightweight theme helpers only. Dawn handles cart, search, drawers, forms.
 */
(() => {
  const MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

  class NadhorReveal extends HTMLElement {
    connectedCallback() {
      if (MOTION_QUERY.matches || document.body.dataset.nadhorMotion === 'false') {
        this.classList.add('is-visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this._observer.unobserve(this);
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }
      );

      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  class NadhorScrollRow extends HTMLElement {
    connectedCallback() {
      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this._onKeydown);
    }

    _onKeydown = (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const delta = event.key === 'ArrowRight' ? 280 : -280;
      this.scrollBy({ left: delta, behavior: MOTION_QUERY.matches ? 'auto' : 'smooth' });
    };
  }

  function register() {
    if (!customElements.get('nadhor-reveal')) {
      customElements.define('nadhor-reveal', NadhorReveal);
    }
    if (!customElements.get('nadhor-scroll-row')) {
      customElements.define('nadhor-scroll-row', NadhorScrollRow);
    }
  }

  register();

  document.addEventListener('shopify:section:load', register);
  document.addEventListener('shopify:section:unload', () => {});
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('.nadhor-atlanta-card, .nadhor-collection-duo__card');
    if (card) card.scrollIntoView({ behavior: MOTION_QUERY.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
  });
})();
